import { apiUrl } from "../../../setting";

/* CREATE */
export const addMainMenuUrl = () => {
  return apiUrl + "/main-menus";
};

/* LIST */
export const getMainMenuUrl = () => {
  return apiUrl + "/main-menus";
};

/* DELETE */
export const deleteMainMenuUrl = (id) => {
  return apiUrl + "/main-menus/" + id;
};

/* UPDATE */
export const updateMainMenuUrl = (id) => {
  return apiUrl + "/main-menus/" + id;
};